import { isRTL } from '@ms/yammer-i18n';

import { Locale, YammerI18nState } from '../../state/types';

export const getCurrentLocale: (state: YammerI18nState) => Locale = (state) => state.i18n.currentLocale;

export const getPreviousLocale: (state: YammerI18nState) => Locale = (state) => state.i18n.previousLocale;

export const isCurrentLocaleRTL: (state: YammerI18nState) => boolean = (state) => isRTL(state.i18n.currentLocale);
